import React from 'react';
import { Box } from 'fw/components';
import { Button, Glyphicon } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import List from './QueryList';
import API from 'fw/system/API';
import * as Notifications from 'fw/globals/Notifications';
import * as Help from 'modules/app/Help';

class QueryPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        return {
            list: null,
            filters: {},
            sortField: props.sortField,
            sortDirection: props.sortDirection,
            rowCount: props.rowCount,
            showMoreRecords: false
        };
    }

    setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

    onSort = (sortField, sortDirection) => {
        this.setState({
            sorting: {
                sortField: sortField,
                sortDirection: sortDirection
            }
        }, function () { this.search(); });
    }

    search = (opts, callback) => {
        const rq = Object.assign(
            this.state.filters,
            this.state.sorting,
            { rowCount: this.state.rowCount }
        );

        new API().post(this.props.list.url, rq,
            {
                success: (r) => {
                    // Update state
                    this.setState({
                        list: r.data,
                        showMoreRecords: r.data.items && (r.data.items.length >= this.state.rowCount)
                    });

                    // Only show notifications if user triggred the search, to avoid messages
                    // after save or other auto refreshes
                    if (!opts || !opts.systemTriggered) {
                        if (!r.data.items || r.data.items.length === 0)
                            Notifications.error("No results found.");
                    }

                    // Callback
                    if (callback)
                        callback();
                }
            });
    }

    onSearch = (filters, callback) => {
        this.setState({
            filters: filters,
            editing: false,
            rowCount: this.props.rowCount
        }, function () {
            this.search(null, callback);
        });
    }

    onError = (error) => {
        Notifications.error(error.errorMessage);
    }

    onLoadMoreResults = () => {
        this.setState({
            rowCount: this.state.rowCount + this.props.rowCount
        }, function () { this.search() });
    }

    onExportData = () => {
        const rq = Object.assign(
            this.state.filters,
            this.state.sorting,
            { rowCount: this.props.exportLimit });

        new API().post(this.props.list.export, rq,
            {
                success: (sr) => {
                    new API().download(sr.data);
                }
            });
    }

    componentDidMount() {
        this.setHelp();
    }

    render() {
        const Search = this.props.Search;

        return (
            <React.Fragment>
                <ContentHeader title={this.props.title} description={this.props.description}>
                </ContentHeader>
                <ContentBody>
                    <Box boxStyle="primary">
                        <Search
                            onSearch={this.onSearch}
                            onError={this.onError} />

                        <List
                            comp={this.props.Item}
                            list={this.state.list}
                            onSort={this.onSort} />
                        <br />

                        {this.props.enableExport && this.state.list &&
                            <Button
                                onClick={this.onExportData}
                                className="btn btn-default pull-left" >
                                <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />Export CSV
                            </Button>
                        }

                        {this.state.showMoreRecords &&
                            <Button id="btnViewMoreResults" className="pull-right" onClick={this.onLoadMoreResults}>
                                <Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results
                    </Button>
                        }

                    </Box>
                </ContentBody>
            </React.Fragment>
        );
    }
}

QueryPage.defaultProps = {
    enableExport: true,
    rowCount: 50,
    sortDirection: "ASC",
    sortField: "",
    exportLimit: 5000
};

export default QueryPage;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/query/QueryPage.js